import {AuthConfig, OAuthService} from "angular-oauth2-oidc";
import {TenantService} from "../tenant/tenant.service";
import {TenantDto} from "../tenant/tenant.dto";
import {AuthConfigService} from "./auth-config.service";

export function authInitializerFn(oauthService: OAuthService, tenantService: TenantService, authConfigService: AuthConfigService): () => Promise<void> {

    return () => new Promise<void>((resolve, reject) => {
        const authConfig = authConfigService.getConfig();

        // E2E mode: skip OAuth2 discovery and login
        if (authConfig.e2e) {
            console.log('[E2E] Auth bypass active - skipping OAuth2 flow');

            // Set tenantInfo in localStorage so components (footer, guards, etc.) can read it
            const tenantInfo: TenantDto = {
                tenant: authConfig.tenant_alias,
                name: 'E2E Test Tenant',
                logo: '',
                logoColorBright: '',
                logoColorDark: '',
                logoBright: '',
                logoDark: ''
            };
            localStorage.setItem('tenantInfo', JSON.stringify(tenantInfo));

            resolve();
            return;
        }

        tenantService.fetchTenantInfo().subscribe({
            next: (tenantDto: TenantDto) => {


                const authConfiguration: AuthConfig = {
                    issuer: authConfig.oauth2_issuer,
                    redirectUri: window.location.origin + '/index.html',
                    clientId: authConfig.tenant_alias,
                    responseType: 'code',
                    scope: 'openid profile',
                    showDebugInformation: true,
                    requireHttps: false,
                    sessionChecksEnabled: false
                };

                authConfiguration.clientId = tenantDto.tenant;


                oauthService.configure(authConfiguration);
                oauthService.loadDiscoveryDocumentAndTryLogin().then(() => {
                    if (oauthService.hasValidAccessToken()) {
                        resolve();
                    } else {
                        oauthService.initImplicitFlow();
                        resolve();
                    }
                }).catch(err => reject(err));
            },
            error: err => reject(err)
        });
    });
}

